import { h, Component } from 'preact';
import { Router } from 'preact-router';
import firebase, { auth, provider } from '../firebaseConfig';

import Home from '../routes/home';
import Signin from '../routes/signin';
import NewPayment from '../routes/payments/new';
import EditPayment from '../routes/payments/edit';
import NotFound from '../routes/404';
import Snackbar from 'preact-material-components/Snackbar';
import Button from 'preact-material-components/Button';

export default class App extends Component {
	state = {
		user: null,
		selectedRoute: '',
	}

	constructor() {
		super();
		this.bar = null;
	}

	componentDidMount() {
		const that = this

		auth.onAuthStateChanged(function(user){
			that.setState({ 
				user: user
			})
		})
	}

	handleRoute = e => {
		this.setState({
			selectedRoute: e.url
		});
	};

	render(props, state) {
		return (
			<div className="main">
				<div id="app">
					<Router onChange={this.handleRoute}>
						<Home path="/" {...this.state} bar={this.bar} />
						<Signin path="/oauth/google" bar={this.bar} {...this.state} />
											
						<NewPayment path="/payments/new/" bar={this.bar} {...this.state} />
						<EditPayment path="/payment/:firebaseId" bar={this.bar} {...this.state} />

						<NotFound default {...this.state} />
					</Router>
				</div>

				<Snackbar ref={(bar) => { this.bar = bar; }} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js